import React from 'react';

import ColumnsTable from './ColumnsTable';
import SearchCriteriaTable from './SearchCriteriaTable';
import SortTable from './SortTable';

const ColumnsTab = ({ sortFullWidth }) => {
  return (
    <>
      <ColumnsTable />
      <SearchCriteriaTable />
      <SortTable sortFullWidth={sortFullWidth} />
    </>
  );
};

export default ColumnsTab;
